import { Head, Link, useForm, usePage } from '@inertiajs/react'
import GoogleSignInButton from '../../components/GoogleSignInButton'
import AuthPanel from '../../components/AuthPanel'
import TextField from '../../components/TextField'
import { buttonClass, linkClass } from '../../components/ui'
import type { SharedProps } from '../../types'

export default function RegistrationsNew() {
  const { google_sign_in_enabled } = usePage<SharedProps>().props
  const form = useForm({ name: '', email_address: '', password: '', password_confirmation: '' })

  return (
    <>
      <Head title="Create your account" />
      <AuthPanel
        title="Create your free account"
        description="You can add your golf details next. Your name is optional."
        footer={<>Already have an account? <Link href="/session/new" className={linkClass}>Sign in</Link></>}
      >
        <form
          className="space-y-5"
          aria-busy={form.processing}
          onSubmit={(e) => {
            e.preventDefault()
            form.post('/registration')
          }}
        >
          <TextField label="Name" name="name" autoComplete="name" error={form.errors.name}
            value={form.data.name} onChange={(v) => form.setData('name', v)} />
          <TextField label="Email" name="email_address" type="email" autoComplete="username" required error={form.errors.email_address}
            value={form.data.email_address} onChange={(v) => form.setData('email_address', v)} />
          <TextField label="Password (10+ characters)" name="password" type="password" autoComplete="new-password" required error={form.errors.password}
            value={form.data.password} onChange={(v) => form.setData('password', v)} />
          <TextField label="Confirm password" name="password_confirmation" type="password" autoComplete="new-password" required
            error={form.errors.password_confirmation}
            value={form.data.password_confirmation} onChange={(v) => form.setData('password_confirmation', v)} />
          <button type="submit" className={`${buttonClass} w-full`} disabled={form.processing}>
            {form.processing ? 'Creating account…' : 'Create account'}
          </button>
        </form>
        {google_sign_in_enabled && <GoogleSignInButton />}
      </AuthPanel>
    </>
  )
}
